import { inject, Injectable } from '@angular/core';
import {
    AddEditLabelDialogComponent, AddEditLabelDialogComponentModel,
} from '@client/app/feature-modules/admin/modules/admin-labels/components/add-edit-label-dialog/add-edit-label-dialog.component';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslocoService } from '@jsverse/transloco';
import { LabelInUseDialogComponent } from '@client/app/feature-modules/admin/modules/admin-labels/components/label-in-use-dialog/label-in-use-dialog.component';
import { TypedPrimeNgDialogRef } from '@client/types/helpers/prime-ng-dialog-type';
import { ComputedLabel } from '@client/app/feature-modules/admin/modules/admin-labels/components/admin-labels/admin-labels.component';

type OpenLabelDialogOptions = {
    model: AddEditLabelDialogComponentModel | null,
    header: {
        text: string;
    }
};

@Injectable()
export class LabelDialogService {
    dialogService = inject(DialogService);
    translocoService = inject(TranslocoService);

    openLabelDialog (options: OpenLabelDialogOptions) {
        const dialogRef = this.dialogService.open(AddEditLabelDialogComponent, {
            header: options.header.text,
            baseZIndex: 10000,
            showHeader: true,
            closable: true,
            dismissableMask: true,
            width: '800px',
            modal: true,
        });

        dialogRef.onChildComponentLoaded.subscribe((component: AddEditLabelDialogComponent) => {
            component.formModel.set(options.model || {
                colorCode: '',
                labelName: '',
            });
            component.formSubmit.subscribe((results) => dialogRef.close(results));
        });

        return dialogRef;
    }

    openLabelInUseDialog (options: OpenLabelDialogOptions) {
        const dialogRef: TypedPrimeNgDialogRef<
            AddEditLabelDialogComponent,
            AddEditLabelDialogComponentModel | null
        > = this.dialogService.open(AddEditLabelDialogComponent, {
            header: options.header.text,
            baseZIndex: 10000,
            showHeader: true,
            closable: true,
            dismissableMask: true,
            width: '800px',
            modal: true,
        });

        return dialogRef;
    }

    openLabelInUseDialogSimple (label: ComputedLabel): TypedPrimeNgDialogRef<
        LabelInUseDialogComponent,
        { goToOverview: boolean }
    > {
        return this.dialogService.open(LabelInUseDialogComponent, {
            header: this.translocoService.translate('admin.labels.labelInUseDialog.header'),
            baseZIndex: 10000,
            showHeader: true,
            closable: true,
            dismissableMask: true,
            contentStyle: { 'overflow-y': 'visible' },
            width: '600px',
            modal: true,
            data: { label },
        });
    }
}
